import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutusMainComponent } from './aboutus-main/aboutus-main.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AboutusEmblaComponent } from './aboutus-embla/aboutus-embla.component';
import { AboutusContributorsComponent } from './aboutus-contributors/aboutus-contributors.component';
import { ContributorSectionComponent } from './contributor-section/contributor-section.component';

@NgModule({
  declarations: [AboutusMainComponent, AboutusEmblaComponent, AboutusContributorsComponent, ContributorSectionComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class AboutusModule { }

// translation loader moved to SharedModule
